import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { DesktopNav } from './navigation/DesktopNav';
import { MobileNav } from './navigation/MobileNav';

export interface MainMenuProps {
  adjustFontSize: (delta: number) => void;
  fontSize: number;
}

export function MainMenu({ adjustFontSize, fontSize }: MainMenuProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const location = useLocation();

  // Close mobile menu when route changes
  React.useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
    <nav className="bg-white dark:bg-accessible-gray-900 high-contrast:bg-black border-b border-accessible-gray-200/50 dark:border-accessible-gray-700/50 high-contrast:border-white/20 shadow-sm relative z-[100] overflow-visible">
      <div className="max-w-7xl mx-auto px-4" role="navigation" aria-label="Nawigacja główna">
        <div className="flex items-center justify-between min-h-14 py-2">
          <div className="flex items-center gap-2">
            <Link 
              to="/" 
              className="flex items-center gap-3 logo-link nav-link tap-target" 
              aria-label="Strona główna"
            >
              <img
                src="/images/F_Znajdki_logo_RGB.jpg"
                alt="Logo Fundacji Znajdki"
                className="w-24 h-24 object-cover"
              />
            </Link>
          </div>
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 transition-colors z-[110] relative tap-target"
            aria-expanded={isMobileMenuOpen}
            aria-label={isMobileMenuOpen ? "Zamknij menu" : "Otwórz menu"}
          >
            <Menu className="w-5 h-5 text-accessible-gray-700 dark:text-white high-contrast:text-white" />
          </button>

          <DesktopNav
            adjustFontSize={adjustFontSize}
            fontSize={fontSize}
          />
        </div>
      </div>
    </nav>
    
    <MobileNav
      isOpen={isMobileMenuOpen}
      setIsOpen={setIsMobileMenuOpen}
      adjustFontSize={adjustFontSize}
      fontSize={fontSize}
    />
    </>
  );
}